import { User } from "@/types/user"
import { UseQueryResult, useQuery, useQueryClient } from "@tanstack/react-query"
import { cosineDelete, cosinePut } from "./default-query"
import { TeamKey } from "./teams"
import { useCosineMutation } from "./mutation"

export const UserKey = "user"

export const useMe = (options?: { enabled?: boolean }): UseQueryResult<User> => {
  const user = useQuery<User>({ queryKey: [UserKey, `/users/me`], enabled: options?.enabled })
  return user
}

export type AccessType = { type: "user"; user: User } | { type: "anon" }

export const useAccess = () => {
  const user = useQuery<User>({
    queryKey: [UserKey, `/users/me`],
  })

  const accessType: AccessType = user.data ? { type: "user", user: user.data } : { type: "anon" }

  return {
    ...accessType,
    loading: user.isLoading,
  }
}

export const useDeleteSelf = (uid: string) => {
  const queryClient = useQueryClient()

  return useCosineMutation<object, any, null>({
    mutationFn: () => cosineDelete(`/users/${uid}`),
    event: "delete_user_self",
    onSuccess: () => queryClient.setQueryData([UserKey], null),
  })
}

export const useUpdateSelf = (uid: string) => {
  const queryClient = useQueryClient()
  return useCosineMutation<
    User,
    any,
    { email?: string; name?: string; image?: string; teamId?: string }
  >({
    mutationFn: (data) => cosinePut(`/users/${uid}`, data),
    onSuccess: (data) => {
      queryClient.setQueryData([UserKey, "/users/me"], data)
      queryClient.invalidateQueries({ queryKey: [TeamKey] })
    },
  })
}
